export default {
  'abnormal': {
    '403': {
      'description': 'Sorry, you don\'t have access to this page.'
    },
    '404': {
      'description': 'Sorry, the page you visited does not exist.'
    },
    '500':{
      'description': 'Sorry, the server is reporting an error.'
    },
    'backHome': 'Back Home'
  }
}